module.exports = __webpack_public_path__ + "static/media/wmsui32_2225.e47ab12c.ico";